import { createContext } from 'react'
import { SideSheetsHistory } from '../typings/SideSheetsHistory'

export const SideSheetsHistoryContext = createContext<
  SideSheetsHistory | undefined
>(undefined)
